import React, { useState } from "react";
import { HardDrive, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

// "Simpan ke Drive" for a platform-stored video/image (expires after 30 days). `refId` = "<messageId>:<path>" or "task:<taskId>:<path>".
export function MediaDriveSave({ media, refId, onSaved, dark = false, compact = false }) {
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(null);
  const done = saved || (media.drive_id ? { drive_id: media.drive_id, link: media.link } : null);
  if (!media.path || !refId) return null;
  if (done) return <a href={done.link} target="_blank" rel="noreferrer" className={`flex items-center gap-1 rounded-lg px-2 py-1 text-[11px] font-semibold ${dark ? "bg-emerald-400/20 text-emerald-200" : "bg-emerald-50 text-emerald-700"}`} data-testid="media-drive-saved"><Check size={11} /> Tersimpan di Drive</a>;
  const save = async () => {
    setBusy(true);
    try {
      const st = (await api.get("/integrations/google/status")).data;
      if (!st?.connected) { toast.error("Hubungkan Google Drive dulu di menu Integrasi"); window.location.href = "/integrations"; return; }
      const r = await api.post("/gallery/drive-save", { id: refId });
      setSaved({ drive_id: r.data.drive_id, link: r.data.link }); onSaved?.(r.data);
      toast.success("Tersimpan ke Google Drive (folder Oryntix) — aman dari penghapusan 30 hari");
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal menyimpan ke Drive"); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={save} disabled={busy} title="Amankan ke Google Drive sebelum terhapus otomatis (retensi 30 hari)" data-testid="media-save-drive"
      className={`flex items-center gap-1 rounded-lg px-2 py-1 text-[11px] font-semibold transition disabled:opacity-60 ${dark ? "bg-emerald-400/20 text-emerald-100 hover:bg-emerald-400/30" : "bg-emerald-600 text-white hover:bg-emerald-700"}`}>
      {busy ? <Loader2 size={11} className="animate-spin" /> : <HardDrive size={11} />} {compact ? "Ke Drive" : "Simpan ke Drive"}
    </button>
  );
}
